import router from "@/router";
import store from "@/store";
import NProgress from "nprogress";
import "nprogress/nprogress.css";
import { PERMISSION_ROLE } from "@/utils/constant";
import { getSEOConfig, setPageSEO } from "@/utils/seoConfig";

NProgress.configure({ showSpinner: false });

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start();
  const roleMap = store.getters.role;
  if (!roleMap.has(PERMISSION_ROLE.MENU)) {
    await store.dispatch("permission/getMenuList");
    await store.dispatch("permission/getMenuListAll");
  }
  if (!roleMap.has(PERMISSION_ROLE.SITE)) {
    await store.dispatch("permission/getSiteInfo");
  }
  await store.dispatch("permission/getActiveMenu", to);
  // 每次跳转页面之前, 清空 详情页title, 避免面包屑在跳转详情页时, 依旧会显示上一篇文章标题, 过一会儿才切换的异常出现
  store.commit("permission/SET_DETAIL_TITLE", "");

  // 设置页面SEO信息
  const seoConfig = getSEOConfig(to.path);
  setPageSEO(seoConfig, true);

  next();
});
router.afterEach(() => {
  // finish progress bar
  NProgress.done();
});
